import { render, staticRenderFns } from "./product-operate-log.vue?vue&type=template&id=76fed52a&scoped=true&"
import script from "./product-operate-log.vue?vue&type=script&lang=js&"
export * from "./product-operate-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fed52a",
  null
  
)

export default component.exports